import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ServicioDatosBase } from '../libs/ruvpp-angular2-comun/ServicioDatosBase';
import { JsonResponse } from '../modelo';
import { Car, CatalogoManoObraDTO, DatosElementoDTO, ElementosDTO, InputActualizarEstatusDocumento, InputActualizarEstatusEspacio, InputActualizarEstatusPrototipo, InputAgregarEspacio, InputAgregarManoObra, InputAgregarPrototipo, InputConsultaUsuario, InputObtenerCatalogoManoObra, InputObtenerCostoManoObra, InputObtenerCostoPrecioUnitarioMateriales, InputObtenerCostoTotalManoObraXElemento, InputObtenerCostoTotalMaterialesXElemento, InputObtenerElementos_Pages, InputObtenerEspacioDetalle, InputObtenerEspacio_Pages, InputObtenerMaterial_Pages, InputObtenerPrototipoDetalle, InputObtenerPrototipo_Pages, InputObtenerReporte, MaterialDTO, OutputActualizarEstatusDocumento, OutputActualizarEstatusEspacio, OutputActualizarEstatusPrototipo, OutputAgregarEspacio, OutputAgregarPrototipo, OutputConsultaUsuario, OutputObtenerCostoManoObra, OutputObtenerCostoPrecioUnitarioMateriales, OutputObtenerCostoTotalManoObraXElemento, OutputObtenerCostoTotalMaterialesXElemento, OutputObtenerEspacioDetalle, OutputObtenerEspacio_Pages, OutputObtenerPrototipoDetalle, OutputObtenerPrototipo_Pages, Usuario, InputObtenerCostoExcelExplosionTotalMateriales, OutputObtenerCostoExcelExplosionTotalMateriales, InputObtenerCostoExcelExplosionXConcepto, OutputObtenerCostoExcelExplosionXConcepto, InputObtenerCostoExcelTotalManoObra, OutputObtenerCostoExcelTotalManoObra, InputObtenerCostoTotalExcelPresupuestoPrototipo, OutputObtenerCostoTotalExcelPresupuestoPrototipo, InputObtenerCostoTotalExcelPrototipo, OutputObtenerCostoTotalExcelPrototipo, InputObtenerReportePrototipo, InputObtenerAmpliacionxConceptoIntegrado, OutputObtenerAmpliacionxConceptoIntegrado, InputObtenerCostoTotalExcelAmpliacion, OutputObtenerCostoTotalExcelAmpliacion, InputObtenerCostoExcelTotalMaterialesAmpliacion, OutputObtenerCostoExcelTotalMaterialesAmpliacion, InputObtenerCostoExcelTotalManoObraAmpliacion, OutputObtenerCostoExcelTotalManoObraAmpliacion, InputObtenerCostoTotalExcelPresupuestoElemento, OutputObtenerCostoTotalExcelPresupuestoElemento, InputObtenerDocuemntosXPrototipo, DocuemntosXPrototipoDTO, InputObtenerCostoTotalExcelPresupuestoAmpliacion, OutputObtenerCostoTotalExcelPresupuestoAmpliacion, InputObtenerDocumentosXAmpliacion, OutputObtenerDocumentosXAmpliacion, InputObtenerAmpliacionModelo, OutputObtenerAmpliacionModelo } from '../modelo/interfaces';

@Injectable({
    providedIn: 'root'
})
export class SimuladorService extends ServicioDatosBase {

    private urlBase: string = environment.urlBase;
    private controller: string = 'externo/api/autentificacion';
    private headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Accept': 'application/json' });

    private urls = {
        ObtenerUsuario: `${this.urlBase}/${this.controller}/ObtenerUsuario`
        , Exportar_PDF: `${this.urlBase}/${this.controller}/Exportar-PDF`
        , AgregarDocumento: `${this.urlBase}/externo/api/fileUpload/add`
        , ObtenerElementos: `${this.urlBase}/externo/api/simulador/ObtenerElementos`

        , AgregarEspacio: `${this.urlBase}/externo/api/simulador/AgregarEspacio`
        , ObtenerEspacioPages: `${this.urlBase}/externo/api/simulador/ObtenerEspacioPages`
        , ObtenerEspacioDetalle: `${this.urlBase}/externo/api/simulador/ObtenerEspacioDetalle`
        , ActualizarEstatusEspacio: `${this.urlBase}/externo/api/simulador/ActualizarEstatusEspacio`

        , AgregarPrototipo: `${this.urlBase}/externo/api/simulador/AgregarPrototipo`
        , ObtenerPrototipoPages: `${this.urlBase}/externo/api/simulador/ObtenerPrototipoPages`
        , ObtenerPrototipoDetalle: `${this.urlBase}/externo/api/simulador/ObtenerPrototipoDetalle`
        , ObtenerDocuemntosXPrototipo: `${this.urlBase}/externo/api/simulador/ObtenerDocuemntosXPrototipo`
        , ActualizarEstatusPrototipo: `${this.urlBase}/externo/api/simulador/ActualizarEstatusPrototipo`
        , ActualizarEstatusDocumento: `${this.urlBase}/externo/api/simulador/ActualizarEstatusDocumento`

        , ObtenerManoObraPages: `${this.urlBase}/externo/api/simulador/ObtenerManoObraPages`
        , AgregarManoObra: `${this.urlBase}/externo/api/simulador/AgregarManoObra`

        , ObtenerElementosPages: `${this.urlBase}/externo/api/simulador/ObtenerElementosPages`

        , ObtenerMaterialPages: `${this.urlBase}/externo/api/simulador/ObtenerMaterialPages`

        , ObtenerCostoManoObra: `${this.urlBase}/externo/api/simulador/ObtenerCostoManoObra`
        , ObtenerCostoPrecioUnitarioMateriales: `${this.urlBase}/externo/api/simulador/ObtenerCostoPrecioUnitarioMateriales`
        , ObtenerCostoTotalManoObraXElemento: `${this.urlBase}/externo/api/simulador/ObtenerCostoTotalManoObraXElemento`
        , ObtenerCostoTotalMaterialesXElemento: `${this.urlBase}/externo/api/simulador/ObtenerCostoTotalMaterialesXElemento`

        , ObtenerCostoExcelExplosionTotalMateriales: `${this.urlBase}/externo/api/simulador/ObtenerCostoExcelExplosionTotalMateriales`
        , ObtenerCostoExcelExplosionXConcepto: `${this.urlBase}/externo/api/simulador/ObtenerCostoExcelExplosionXConcepto`
        , ObtenerCostoExcelTotalManoObra: `${this.urlBase}/externo/api/simulador/ObtenerCostoExcelTotalManoObra`
        , ObtenerCostoTotalExcelPresupuestoPrototipo: `${this.urlBase}/externo/api/simulador/ObtenerCostoTotalExcelPresupuestoPrototipo`
        , ObtenerCostoTotalExcelPrototipo: `${this.urlBase}/externo/api/simulador/ObtenerCostoTotalExcelPrototipo`
        , ObtenerCostoTotalExcelPresupuestoElemento: `${this.urlBase}/externo/api/simulador/ObtenerCostoTotalExcelPresupuestoElemento`

        , ObtenerReporte: `${this.urlBase}/externo/api/simulador/ObtenerReporte`
        , ObtenerReportePrototipo: `${this.urlBase}/externo/api/simulador/ObtenerReportePrototipo`

        , ObtenerAmpliacionxConceptoIntegrado: `${this.urlBase}/externo/api/simulador/ObtenerAmpliacionxConceptoIntegrado`
        , ObtenerCostoTotalExcelAmpliacion: `${this.urlBase}/externo/api/simulador/ObtenerCostoTotalExcelAmpliacion`
        , ObtenerCostoExcelTotalManoObraAmpliacion: `${this.urlBase}/externo/api/simulador/ObtenerCostoExcelTotalManoObraAmpliacion`
        , ObtenerCostoExcelTotalMaterialesAmpliacion: `${this.urlBase}/externo/api/simulador/ObtenerCostoExcelTotalMaterialesAmpliacion`
        , ObtenerCostoTotalExcelPresupuestoAmpliacion: `${this.urlBase}/externo/api/simulador/ObtenerCostoTotalExcelPresupuestoAmpliacion`
        , ObtenerAmpliacionModelo: `${this.urlBase}/externo/api/simulador/ObtenerAmpliacionModelo`
        , ObtenerDocumentosXAmpliacion: `${this.urlBase}/externo/api/simulador/ObtenerDocumentosXAmpliacion`

    };

    /**
     * 
     * @param http
     */
    constructor(http: HttpClient) {
        super(http);
    }

    /**
     * 
     * @param entity
     */
    public Autentificacion(entity: Usuario) {

        let obj: InputConsultaUsuario = <InputConsultaUsuario>{ id_usuario: entity.user, contrasenia: entity.password };

        return this.post<JsonResponse<OutputConsultaUsuario>>(this.urls.ObtenerUsuario, JSON.stringify(obj), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public Exportar_PDF(entity: Usuario) {
        return this.post<JsonResponse<string>>(this.urls.Exportar_PDF, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     */
    public ObtenerElementos() {
        return this.post<JsonResponse<DatosElementoDTO>>(this.urls.ObtenerElementos, JSON.stringify(""), { headers: this.headers });
    }

    ///**
    // * 
    // * @param listElementos
    // */
    //public ObtenerCostoManoObra(listElementos: number[]) {
    //    return this.post<JsonResponse<Array<OutputObtenerCostoManoObra>>>(this.urls.ObtenerCostoManoObra, JSON.stringify(listElementos), { headers: this.headers });
    //}

    ///**
    // * 
    // * @param listElementos
    // */
    //public ObtenerPrecioUnitario(listElementos: number[]) {

    //    return this.post<JsonResponse<Array<OutputObtenerPrecioUnitario>>>(this.urls.ObtenerPrecioUnitario, JSON.stringify(listElementos), { headers: this.headers });
    //}

    ///**
    // * 
    // * @param entity
    // */
    //public ObtenerPrecioUnitarioEspacio(entity: InputObtenerPrecioUnitarioEspacio) {

    //    return this.post<JsonResponse<Array<OutputObtenerPrecioUnitarioEspacio>>>(this.urls.ObtenerPrecioUnitarioEspacio, JSON.stringify(entity), { headers: this.headers });
    //}

    ///**
    // * 
    // * @param entity
    // */
    //public ObtenerTotalManoObra(entity: InputObtenerTotalManoObra) {

    //    return this.post<JsonResponse<Array<OutputObtenerTotalManoObra>>>(this.urls.ObtenerTotalManoObra, JSON.stringify(entity), { headers: this.headers });
    //}

    ///**
    // * 
    // * @param entity
    // */
    //public ObtenerTotalManoObraXElemento(entity: InputObtenerTotalManoObraXElemento) {

    //    return this.post<JsonResponse<Array<OutputObtenerTotalManoObraXElemento>>>(this.urls.ObtenerTotalManoObraXElemento, JSON.stringify(entity), { headers: this.headers });
    //}

    ///**
    // * 
    // * @param entity
    // */
    //public ObtenerTotalMateriales(entity: InputObtenerTotalMateriales) {

    //    return this.post<JsonResponse<Array<OutputObtenerTotalMateriales>>>(this.urls.ObtenerTotalMateriales, JSON.stringify(entity), { headers: this.headers });
    //}

    ///**
    // * 
    // * @param entity
    // */
    //public ObtenerTotalMaterialesXElemento(entity: InputObtenerTotalMaterialesXElemento) {

    //    return this.post<JsonResponse<Array<OutputObtenerTotalMaterialesXElemento>>>(this.urls.ObtenerTotalMaterialesXElemento, JSON.stringify(entity), { headers: this.headers });
    //}

    //*************************************************************************************************************************************************************************

    /**
     * 
     * @param entity
     */
    public AgregarEspacio(entity: InputAgregarEspacio) {

        return this.post<JsonResponse<OutputAgregarEspacio>>(this.urls.AgregarEspacio, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * 
     */
    public ObtenerEspacioPages(entity: InputObtenerEspacio_Pages) {
        return this.post<JsonResponse<OutputObtenerEspacio_Pages>>(this.urls.ObtenerEspacioPages, JSON.stringify(entity), { headers: this.headers });
    }

    /**
    * 
    * @param entity
    */
    public ObtenerEspacioDetalle(entity: InputObtenerEspacioDetalle) {

        return this.post<JsonResponse<OutputObtenerEspacioDetalle>>(this.urls.ObtenerEspacioDetalle, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public ActualizarEstatusEspacio(entity: InputActualizarEstatusEspacio) {

        return this.post<JsonResponse<OutputActualizarEstatusEspacio>>(this.urls.ActualizarEstatusEspacio, JSON.stringify(entity), { headers: this.headers });
    }


    //*************************************************************************************************************************************************************************


    /**
     * 
     * @param entity
     */
    public AgregarPrototipo(entity: InputAgregarPrototipo) {

        return this.post<JsonResponse<OutputAgregarPrototipo>>(this.urls.AgregarPrototipo, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public ObtenerPrototipoPages(entity: InputObtenerPrototipo_Pages) {
        return this.post<JsonResponse<OutputObtenerPrototipo_Pages>>(this.urls.ObtenerPrototipoPages, JSON.stringify(entity), { headers: this.headers });
    }

    /**
    * 
    * @param entity
    */
    public ObtenerPrototipoDetalle(entity: InputObtenerPrototipoDetalle) {

        return this.post<JsonResponse<OutputObtenerPrototipoDetalle>>(this.urls.ObtenerPrototipoDetalle, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public ObtenerDocuemntosXPrototipo(entity: InputObtenerDocuemntosXPrototipo) {

        return this.post<JsonResponse<DocuemntosXPrototipoDTO>>(this.urls.ObtenerDocuemntosXPrototipo, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public ActualizarEstatusPrototipo(entity: InputActualizarEstatusPrototipo) {

        return this.post<JsonResponse<OutputActualizarEstatusPrototipo>>(this.urls.ActualizarEstatusPrototipo, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public ActualizarEstatusDocumento(entity: InputActualizarEstatusDocumento) {

        return this.post<JsonResponse<OutputActualizarEstatusDocumento>>(this.urls.ActualizarEstatusDocumento, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public ObtenerManoObraPages(entity: InputObtenerCatalogoManoObra) {

        return this.post<JsonResponse<CatalogoManoObraDTO>>(this.urls.ObtenerManoObraPages, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public AgregarManoObra(entity: InputAgregarManoObra) {

        return this.post<JsonResponse<number>>(this.urls.AgregarManoObra, JSON.stringify(entity), { headers: this.headers });
    }



    /**
     * 
     * @param entity
     */
    public ObtenerElementosPages(entity: InputObtenerElementos_Pages) {

        return this.post<JsonResponse<ElementosDTO>>(this.urls.ObtenerElementosPages, JSON.stringify(entity), { headers: this.headers });
    }


    /**
     * 
     * @param entity
     */
    public ObtenerMaterialPages(entity: InputObtenerMaterial_Pages) {

        return this.post<JsonResponse<MaterialDTO>>(this.urls.ObtenerMaterialPages, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public ObtenerCostoManoObra(entity: InputObtenerCostoManoObra) {

        return this.post<JsonResponse<OutputObtenerCostoManoObra[]>>(this.urls.ObtenerCostoManoObra, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public ObtenerCostoPrecioUnitarioMateriales(entity: InputObtenerCostoPrecioUnitarioMateriales) {

        return this.post<JsonResponse<OutputObtenerCostoPrecioUnitarioMateriales[]>>(this.urls.ObtenerCostoPrecioUnitarioMateriales, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public ObtenerCostoTotalManoObraXElemento(entity: InputObtenerCostoTotalManoObraXElemento) {

        return this.post<JsonResponse<OutputObtenerCostoTotalManoObraXElemento>[]>(this.urls.ObtenerCostoTotalManoObraXElemento, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public ObtenerCostoTotalMaterialesXElemento(entity: InputObtenerCostoTotalMaterialesXElemento) {

        return this.post<JsonResponse<OutputObtenerCostoTotalMaterialesXElemento[]>>(this.urls.ObtenerCostoTotalMaterialesXElemento, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public ObtenerCostoExcelExplosionTotalMateriales(entity: InputObtenerCostoExcelExplosionTotalMateriales) {

        return this.post<JsonResponse<OutputObtenerCostoExcelExplosionTotalMateriales[]>>(this.urls.ObtenerCostoExcelExplosionTotalMateriales, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public ObtenerCostoExcelExplosionXConcepto(entity: InputObtenerCostoExcelExplosionXConcepto) {

        return this.post<JsonResponse<OutputObtenerCostoExcelExplosionXConcepto[]>>(this.urls.ObtenerCostoExcelExplosionXConcepto, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public ObtenerCostoExcelTotalManoObra(entity: InputObtenerCostoExcelTotalManoObra) {

        return this.post<JsonResponse<OutputObtenerCostoExcelTotalManoObra[]>>(this.urls.ObtenerCostoExcelTotalManoObra, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public ObtenerCostoTotalExcelPresupuestoPrototipo(entity: InputObtenerCostoTotalExcelPresupuestoPrototipo) {

        return this.post<JsonResponse<OutputObtenerCostoTotalExcelPresupuestoPrototipo[]>>(this.urls.ObtenerCostoTotalExcelPresupuestoPrototipo, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public ObtenerCostoTotalExcelPrototipo(entity: InputObtenerCostoTotalExcelPrototipo) {

        return this.post<JsonResponse<OutputObtenerCostoTotalExcelPrototipo[]>>(this.urls.ObtenerCostoTotalExcelPrototipo, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public ObtenerCostoTotalExcelPresupuestoElemento(entity: InputObtenerCostoTotalExcelPresupuestoElemento) {

        return this.post<JsonResponse<OutputObtenerCostoTotalExcelPresupuestoElemento[]>>(this.urls.ObtenerCostoTotalExcelPresupuestoElemento, JSON.stringify(entity), { headers: this.headers });
    }

    /**
    * 
    * @param entity
    */
    public ObtenerReporte(entity: InputObtenerReporte) {

        return this.post<JsonResponse<string>>(this.urls.ObtenerReporte, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public ObtenerReportePrototipo(entity: InputObtenerReportePrototipo) {

        return this.post<JsonResponse<string>>(this.urls.ObtenerReportePrototipo, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public ObtenerAmpliacionxConceptoIntegrado(entity: InputObtenerAmpliacionxConceptoIntegrado) {

        return this.post<JsonResponse<OutputObtenerAmpliacionxConceptoIntegrado>>(this.urls.ObtenerAmpliacionxConceptoIntegrado, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public ObtenerCostoTotalExcelAmpliacion(entity: InputObtenerCostoTotalExcelAmpliacion) {

        return this.post<JsonResponse<OutputObtenerCostoTotalExcelAmpliacion>>(this.urls.ObtenerCostoTotalExcelAmpliacion, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public ObtenerCostoExcelTotalMaterialesAmpliacion(entity: InputObtenerCostoExcelTotalMaterialesAmpliacion) {

        return this.post<JsonResponse<OutputObtenerCostoExcelTotalMaterialesAmpliacion>>(this.urls.ObtenerCostoExcelTotalMaterialesAmpliacion, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public ObtenerCostoTotalExcelPresupuestoAmpliacion(entity: InputObtenerCostoTotalExcelPresupuestoAmpliacion) {

        return this.post<JsonResponse<OutputObtenerCostoTotalExcelPresupuestoAmpliacion>>(this.urls.ObtenerCostoTotalExcelPresupuestoAmpliacion, JSON.stringify(entity), { headers: this.headers });
    }

    /**
    * 
    * @param entity
    */
    public ObtenerCostoExcelTotalManoObraAmpliacion(entity: InputObtenerCostoExcelTotalManoObraAmpliacion) {

        return this.post<JsonResponse<OutputObtenerCostoExcelTotalManoObraAmpliacion>>(this.urls.ObtenerCostoExcelTotalManoObraAmpliacion, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public ObtenerAmpliacionModelo(entity: InputObtenerAmpliacionModelo) {

        return this.post<JsonResponse<OutputObtenerAmpliacionModelo>>(this.urls.ObtenerAmpliacionModelo, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public ObtenerDocumentosXAmpliacion(entity: InputObtenerDocumentosXAmpliacion) {

        return this.post<JsonResponse<OutputObtenerDocumentosXAmpliacion>>(this.urls.ObtenerDocumentosXAmpliacion, JSON.stringify(entity), { headers: this.headers });
    }


    /**
     * 
     * @param event
     * @param params
     */
    public AgregarDocumento(event, params) {

        console.log('uploadFiles -->>  event -->> ', event + '    params -->> ', params);

        var formData: FormData = new FormData();

        if (params != null) {
            formData.append('json', JSON.stringify(params));
        }

        let cont = 1;

        for (let file of event.files) {

            formData.append(file.name, file);

            console.log('File [' + (cont) + ']   -->> ', file);

            cont++;

        }

        return this.postFile<JsonResponse<string>>(this.urls.AgregarDocumento, formData);
    }

    //*************************************************************************************************************************************************************************


    /**
     * */
    public getCarsSmall() {
        return this.http.get<any>('assets/data/cars-small.json')
            .toPromise()
            .then(res => <Car[]>res.data)
            .then(data => data);
    }
}
